import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createAccount.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createAccount.error;
export const createAccountDataResponse = (state: RootState) =>
  state.createAccount.createAccountResponse;
